// Public pages of the customer app (no login needed): install guide and terms. The
// activation wizard (Activate.tsx) uses the same frame.
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from '../components/Links';
import { guideFor } from '../guide';

export function PublicFrame({ children }: { children: ReactNode }) {
  return (
    <div className="public">
      <header className="public-head">
        <Link to="/" className="brand"><svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 4 26 27 16 21.5 6 27Z" /></svg>Fleet Functions</Link>
      </header>
      <main className="public-main">{children}</main>
    </div>
  );
}

export function GuideContent({ model }: { model: string | null }) {
  const guide = guideFor(model);
  return (
    <div className="guide">
      <ol className="guide-steps">
        {guide.steps.map((s) => (
          <li key={s.title}>
            <strong>{s.title}</strong>
            <p>{s.text}</p>
            {s.photo && <img src={s.photo} alt={s.title} loading="lazy" />}
          </li>
        ))}
      </ol>
      {guide.leds && (
        <>
          <h3>What the lights mean</h3>
          <dl className="guide-leds">
            {guide.leds.map((l) => <div key={l.light}><dt>{l.light}</dt><dd>{l.meaning}</dd></div>)}
          </dl>
        </>
      )}
    </div>
  );
}

// /guide and /guide/<model>: the install guide on its own, without activating.
export function GuidePage() {
  const { model } = useParams();
  const guide = guideFor(model ?? null);
  return (
    <PublicFrame>
      <div className="wizard-card">
        <h1>{guide.title}{model ? ` – ${model}` : ''}</h1>
        <GuideContent model={model ?? null} />
        <p className="muted small">Fitted it? <Link to="/activate">Activate your tracker</Link>.</p>
      </div>
    </PublicFrame>
  );
}

// PLACEHOLDER until Fleet Functions supplies the real terms and privacy notice. Change
// TERMS_VERSION in api/src/activate.ts whenever the wording changes.
export function TermsPage() {
  return (
    <PublicFrame>
      <div className="wizard-card">
        <h1>Terms and privacy notice</h1>
        <p className="notice">Draft: the final terms and privacy notice will be published here before launch.</p>
        <h3>Service</h3>
        <p>Each self-install tracker includes one year of tracking from the day it is activated. After that, tracking continues when the subscription is renewed.</p>
        <h3>Your data</h3>
        <p>Fleet Functions stores the positions and data your tracker sends so you can see them in the app. Placeholder: how long data is kept, who can see it and your rights will be set out here.</p>
        <p className="muted small"><Link to="/activate">Back to activation</Link></p>
      </div>
    </PublicFrame>
  );
}
